import { Component, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ApiService, CoreUiPartialState, getBrandDefaults } from '@pos-app/core-ui';
import { ROUTE_URL } from '@pos-app/data';
import { ToastrService } from 'ngx-toastr';
import { Subject, BehaviorSubject } from 'rxjs';
import { takeUntil, takeWhile } from 'rxjs/operators';

@Component({
    selector: 'app-forgotpassword',
    templateUrl: './forgotpassword.component.html',
    styleUrls: ['./forgotpassword.component.scss'],
    standalone: false
})
export class ForgotPasswordComponent implements OnInit, OnDestroy {
  forgotPasswordForm: UntypedFormGroup;
  private _loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  loading$ = this._loadingSubject.asObservable();
  get loading(): boolean {
    return this._loadingSubject.value;
  }
  set loading(v: boolean) {
    this._loadingSubject.next(v);
  }
  error = '';

  returnUrl: string;
  alive = true;
  unSubscribe$ = new Subject<void>();
  appTestEnvironment: boolean = false;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private apiService: ApiService,
    private toastr: ToastrService,
    private coreUiStore: Store<CoreUiPartialState>
  ) {}

  ngOnInit() {
    this.forgotPasswordForm = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
    this.coreUiStore
      .select(getBrandDefaults)
      .pipe(takeUntil(this.unSubscribe$))
      .subscribe((data) => {
        this.appTestEnvironment = data?.brand === 'ARBAUS_PY';
      });
  }

  ngOnDestroy() {
    this.alive = false;
  }

  submit() {
    if (!this.forgotPasswordForm.valid) {
      this.forgotPasswordForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.apiService
      .forgottenPassword(this.forgotPasswordForm.value)
      .pipe(takeWhile(() => this.alive))
      .subscribe(
        () => {
          this.toastr.success('Password reset email sent');
          this.router.navigate([ROUTE_URL.login]);
          this.loading = false;
        },
        () => {
          this.loading = false;
          this.error = 'Oops! Something went wrong. Please try again';
        }
      );
  }
}

